import * as React from 'react'
import {FC} from 'react'
import Form from 'antd/lib/form'
import 'antd/lib/form/style'
import InternationalPhone, {
    CountryPhoneMask,
} from '../../custom-form-components/international-phone'
import {STANDARD_ITEM_RULES} from '../../../constants'

export const ID_INTERNATIONAL_PHONE = 'internationalPhone'

interface InternationalPhoneItemProps {
    name?: string | string[]
    countriesPhoneMasks?: CountryPhoneMask[]
}

const InternationalPhoneItem: FC<InternationalPhoneItemProps> = ({
    name = ID_INTERNATIONAL_PHONE,
    countriesPhoneMasks,
}) => {
    return (
        <Form.Item name={name} label={'Телефон'} rules={STANDARD_ITEM_RULES}>
            <InternationalPhone countriesPhoneMasks={countriesPhoneMasks} />
        </Form.Item>
    )
}

export default InternationalPhoneItem
